export default {"src":"/_next/static/media/circle-shape.30cc8f2a.svg","height":494,"width":477};